import React from 'react'

import { AccountActivitySortValue } from 'modules/accountActivity/domain'
import { formatNumber } from 'utils/formatNumbers'

import utilityStyles from '../../../styles/utility.module.css'

const accountActivitySortOptions = {
  //probably better to have this under an asc/desc key too have different labels for each
  [AccountActivitySortValue.MOST_RECENT]: 'most recent activity',
  [AccountActivitySortValue.LEAST_RECENT]: 'least recent activity',
  [AccountActivitySortValue.ENGAGEMENT_SCORE]: 'engagement score',
  [AccountActivitySortValue.CONTACT_NAME]: 'contact name',
  [AccountActivitySortValue.CONTACT_EMAIL]: 'email',
  [AccountActivitySortValue.NUM_ACTIVITIES]: '# of activities',
  [AccountActivitySortValue.CONTACT_ROLE]: 'contact role',
  [AccountActivitySortValue.LOCATION]: 'contact location',
  [AccountActivitySortValue.ACCOUNT_NAME]: 'account name',
  [AccountActivitySortValue.DEAL_NAME]: 'deal name',
  [AccountActivitySortValue.DEAL_AMOUNT]: 'amount',
  [AccountActivitySortValue.DEAL_PROBABILITY]: 'probability',
  [AccountActivitySortValue.DEAL_STAGE]: 'stage name',
  [AccountActivitySortValue.DEAL_FORECAST_CATEGORY]: 'forecast category',
  [AccountActivitySortValue.DEAL_TYPE]: 'type',
  [AccountActivitySortValue.DEAL_OWNER]: 'owner',
  [AccountActivitySortValue.TRENDING]: 'trending'
}

interface Props {
  sort: AccountActivitySortValue
  descending: boolean
  count: number
}

const getSortOption = (sort: AccountActivitySortValue, descending: boolean) => {
  if (accountActivitySortOptions[sort]) {
    if (descending && sort === AccountActivitySortValue.MOST_RECENT) {
      return accountActivitySortOptions[AccountActivitySortValue.LEAST_RECENT]
    }
    return accountActivitySortOptions[sort]
  }
}

const SortDescription = (props: Props) => {
  const { sort, descending, count } = props
  const sortOption = getSortOption(sort, descending)

  return (
    <div>
      Showing{' '}
      <span className={utilityStyles.semiBoldWeight}>
        {`${count ? formatNumber(count) : ''} contact${count !== 1 ? 's' : ''}`}
      </span>
      {sortOption && (
        <>
          <span> sorted by </span>
          <span className={utilityStyles.semiBoldWeight}>{sortOption}</span>
        </>
      )}
    </div>
  )
}

export default SortDescription
